import { useEffect, useState, useRef, useCallback } from 'react';
import RootLayout from 'layouts/RootLayout';
import { liff } from '@line/liff';

const LIFF_ID = process.env.REACT_APP_INVITE_LIFF_ID;
const INVITE_URL = process.env.REACT_APP_INVITE_URL;

const initializeLIFF = async () => {
  try {
    await liff.init({ liffId: LIFF_ID });
    if (!liff.isLoggedIn()) {
      liff.login();
    }
    console.log('LIFF 初始化成功');
    console.log('LIFF：', liff);
    return liff;
  } catch (error: unknown) {
    console.error('初始化 liff 時出錯：', error);
  }
};

const Invite = () => {
  const [liffClientObject, setLiffClientObject] = useState(null);
  const [inviteData, setInviteData] = useState(null);
  const [shareUrl, setShareUrl] = useState('');
  const [loading, setLoading] = useState(true); // 新增 loading 狀態
  const urlRef = useRef<HTMLInputElement>(null);

  const initialize = async () => {
    const liffObject = await initializeLIFF();
    setLiffClientObject(liffObject);
  };

  const fetchInviteData = useCallback(async () => {
    try {
      setLoading(true); // 開始載入
      if (!liffClientObject) {
        throw new Error('LIFF client object is not initialized');
      }

      const userId = liffClientObject.getContext().userId;
      const accessToken = liffClientObject.getAccessToken();

      const response = await fetch(`${INVITE_URL}/${userId}?access_token=${accessToken}`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      console.log('invite data:', data);
      setInviteData(data);
    } catch (error) {
      console.error('取得 invite 資料時出錯：', error);
    } finally {
      setLoading(false); // 結束載入
    }
  }, [liffClientObject]);

  useEffect(() => {
    initialize();
  }, []);

  useEffect(() => {
    if (liffClientObject) {
      fetchInviteData();
    }
  }, [liffClientObject, fetchInviteData]);

  useEffect(() => {
    if (inviteData) {
      setShareUrl(window.location.href + '/line-join/' + inviteData.data.code);
    }
  }, [inviteData]);

  const shareLink = async () => {
    if (!liffClientObject) {
      alert('LIFF 尚未初始化');
      return;
    }

    if (!shareUrl) {
      alert('分享連結尚未生成');
      return;
    }

    try {
      await liff.shareTargetPicker([
        {
          type: 'text',
          text: `邀請您加入【基隆市衛生局】基隆親子照護平台LINE官方帳號：${shareUrl}`,
        },
      ]);
      alert('分享成功，請點選關閉視窗，查看您的 LINE！');
    } catch (error) {
      console.error('分享失敗：', error);
      alert('分享失敗，請稍後再試');
    }
  };

  const closeWindow = () => {
    liff.closeWindow();
  };

  return (
    <RootLayout title="邀請好友">
      {loading ? ( // 根據 loading 狀態顯示
        <div className="flex justify-center items-center h-screen">
          <p>載入中...</p>
        </div>
      ) : (
        <div className="p-6 flex flex-col justify-center items-center">
          請掃描以下 QR Code 加入我們的 Line 官方帳號
          <div className="pb-8 text-xl tracking-wide">
            <img src={`https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(shareUrl)}&size=300x300`}
                 alt="QR Code"/>
          </div>
          <input ref={urlRef} value={shareUrl} readOnly className="mb-2 text-center w-full"/>
          <button onClick={shareLink} className="mb-4 rounded bg-green-500 text-white py-2 px-4 w-full">
            分享連結
          </button>
          {/*<button onClick={copyLink} className="mb-4 rounded bg-yellow-500 text-white py-2 px-4 w-full">*/}
          {/*  複製網址*/}
          {/*</button>*/}
          <button onClick={closeWindow} className="rounded bg-red-500 text-white py-2 px-4 w-full">
            關閉視窗
          </button>
        </div>
      )}
    </RootLayout>
  );
};

export default Invite;